import React, { useEffect, useState } from "react";
import { transformToOptions } from "../../../../../../../AdminPanelPage/helpers/transformToOptions";
import { selectStyles } from "../../../../../../../AdminPanelPage/components/ManageUserTab/types/SelectStyles";
import CreatableSelect from "react-select/creatable";

interface IMultiSelectFieldInputProps {
  values: string[];
  optionsList: string[];
  setValues: (values: string[]) => void;
  placeholderKey: string;
}

const CreateSelectInput: React.FC<IMultiSelectFieldInputProps> = ({
  values,
  optionsList,
  setValues,
  placeholderKey,
}) => {
  const [theme, setTheme] = useState(
    localStorage.getItem("darkMode") === "true",
  );

  useEffect(() => {
    setTheme(localStorage.getItem("darkMode") === "true");
  }, [localStorage.getItem("darkMode")]);

  const handleChange = (newValue: any) => {
    setValues(newValue.map((item: any) => item.value));
  };

  return (
    <CreatableSelect
      isMulti={true}
      value={values?.map((val: string) => ({ value: val, label: val }))}
      onChange={handleChange}
      options={transformToOptions(optionsList.filter((x) => x?.trim())).sort(
        (a, b) => a.label.localeCompare(b.label),
      )}
      isClearable
      placeholder={placeholderKey}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      styles={{
        input: (base) => ({
          ...base,
          color: theme ? "#FFFFFF" : "#000000",
        }),
        option: (base, { isFocused }) => ({
          ...base,
          backgroundColor: isFocused
            ? theme
              ? "#86BC25"
              : "#86BC25"
            : theme
              ? "#374151"
              : "#FFFFFF",
          color: theme ? "#FFFFFF" : "#000000",
          fontSize: "14px",
        }),
        multiValue: (base: any) => ({
          ...base,
          backgroundColor: theme ? "#43B02A" : "#26890D",
        }),
        multiValueLabel: (base: any) => ({
          ...base,
          color: "#e2e8f0",
        }),
        ...selectStyles(theme),
      }}
      formatCreateLabel={(v) => `Create "${v}"`}
    />
  );
};

export { CreateSelectInput };
